
import { doc, onSnapshot, setDoc, getFirestore } from "firebase/firestore";
import { EventBus } from '~/plugins/event-bus';
import { pwaBadge } from '~/composables/pwaBadge';

export default {
  name: "internalIndex",

  components: {
    internalCoreAppBar: () => import("../components/appBar"),
    internalCoreAppBarMobile: () => import("../components/appBarMobile"),
    // internalBarHomeEvent: () => import("../components/barHomeEvent"),
  },

  data: () => ({
    expandOnHover: false,
    showMatchVideo: false,
    showMatchScreen: false,
    newMatch: null,
    highColor: "#fd6666",
    midColor: "#6d4d97",
    badge: null,
    pendingMatchData: null,
  }),

  created() {
    this.validateUserOnFirebase();
    this.listenEventTicketCurrentlyInUseOnFirebase();

    // Initialize PWA badge
    this.badge = pwaBadge();
    this.badge.startWatching();

    // Verificar match pendente no carregamento inicial
    this.fetchMatchData();

    EventBus.$on("playMatchVideo", (matchData) => {
      if (this.isOnboardingActive()) {
        this.pendingMatchData = matchData || true;
        return;
      }
      this.startMatchVideo(matchData);
    });

    EventBus.$on("onboardingClosed", () => {
      if (this.pendingMatchData) {
        const matchData = this.pendingMatchData === true ? null : this.pendingMatchData;
        this.pendingMatchData = null;
        this.startMatchVideo(matchData);
      }
    });
  },

  beforeDestroy() {
    EventBus.$off("playMatchVideo");
    EventBus.$off("onboardingClosed");
    if (this.badge) {
      this.badge.stopWatching();
    }
  },

  computed: {
    eventName() {
      try {
        const event = JSON.parse(localStorage.getItem("event"));
        return event?.name || '';
      } catch (e) {
        return '';
      }
    },
  },

  methods: {
    listenEventTicketCurrentlyInUseOnFirebase() {

      const userFromLocalStorage = localStorage.getItem("user");

      if(userFromLocalStorage === null || userFromLocalStorage === undefined || userFromLocalStorage === "") {
        return;
      }

      let user;
      try {
        user = JSON.parse(userFromLocalStorage);
      } catch (e) {
        return;
      }

      const userId = user?.id || user?.Id;

      if (!userId || typeof userId !== 'string') {
        return;
      }

      const firestore = getFirestore()

      const docRef = doc(firestore, "eventticketcurrentlyinuse", userId);

      onSnapshot(docRef, (snapshot) => {
        // const eventData = snapshot.data();
        // if(eventData === undefined) {
        //   this.$toast.error("O ticket utilizado está em uso.");
        //   this.$router.push("/");
        // }
      });
    },

    async validateUserOnFirebase() {
      const $context = this;

      const userFromLocalStorage = localStorage.getItem("user");

      if(userFromLocalStorage === null || userFromLocalStorage === undefined || userFromLocalStorage === "") {
        return;
      }

      let user;
      try {
        user = JSON.parse(userFromLocalStorage);
      } catch (e) {
        return;
      }

      const userId = user?.id || user?.Id;

      if (!userId || typeof userId !== 'string') {
        return;
      }

      const firestore = getFirestore()

      const docRef = doc(firestore, "user", userId);

      await setDoc(docRef, { event: null });

      onSnapshot(docRef, (snapshot) => {
        const eventData = snapshot.data();
        if(eventData == null) return;
        const data = JSON.parse(eventData.event);
        if(data == null) return;
        const messageObj = (data.message !== null && data.message !== "") ? JSON.parse(data.message) : "";
        const socketEvent = {
          conversationId: messageObj.conversationId,
          senderId: messageObj.senderId,
          message: messageObj,
          eventType: data.eventType,
        };
        $context.treatEventData(socketEvent);
      });
    },

    treatEventData(socketEvent) {
      switch (socketEvent.eventType) {
        case "UpdateNotifications":
          EventBus.$emit("updateNotifications");
          EventBus.$emit("twoUsersSixMessagesEachDialog1",socketEvent.message);
          break;
        case "NewMessage":
          EventBus.$emit("NewMessage", socketEvent.message);
          EventBus.$emit("updateNotifications");
          break;
        case "Connection":
          EventBus.$emit("newConnection");
          EventBus.$emit("newNotification", socketEvent);
          break;
        case "NewSleeping":
          EventBus.$emit("NewSleeping");
          EventBus.$emit("newNotification", socketEvent);
          EventBus.$emit("updateMatchList");
          EventBus.$emit("updateNotifications");
          break;
        case "Awakening":
          EventBus.$emit("Awakening");
          EventBus.$emit("updateMatchList");
          EventBus.$emit("updateNotifications");
          break;
        case "createMatches":
          EventBus.$emit("createMatches");
          EventBus.$emit("newNotification", socketEvent);
          EventBus.$emit("updateMatchList");
          EventBus.$emit("updateNotifications");
          EventBus.$notifications.connections += 1;
          EventBus.$emit("badgeUpdated");
          this.fetchMatchData();
          break;
        case "AcceptAwakening":
          EventBus.$emit("AcceptAwakening");
          EventBus.$emit("updateMatchList");
          EventBus.$emit("updateNotifications");
          break;
        case "reminder":
          EventBus.$emit("reminder");
          break;
        case "reminderWeeks":
          EventBus.$emit("reminderWeeks");
          break;
        case "suspendUser":
          EventBus.$emit("suspendUser");
          localStorage.clear()
          localStorage.setItem("suspendedObject", JSON.stringify(socketEvent.message));
          this.$router.push("auth/");
          break;
      }
    },

    styleMethod() {
      let result = "";
      result = this.$vuetify.breakpoint.mdAndUp ? "margin-left: 90px;" : "";
      return result;
    },
    chat() {
      this.$router.push("/conversation");
    },
    openMsgDrawer() {
      // paliativo até se encontrar uma solução para o problema de responsividade
      // da drawer quando está clipped
      this.messageDrawer = false;
      this.messageDrawer = true;
    },
    closeDrawer() {
      this.messageDrawer = false;
    },

    onMatchVideoEnded() {
      this.showMatchVideo = false;
      this.showMatchScreen = true;
      EventBus.$emit("matchVideoEnded");
    },

    setMatchData(matchData) {
      const userFromLocalStorage = localStorage.getItem("user");
      if (!userFromLocalStorage) return;

      const user = JSON.parse(userFromLocalStorage);
      this.newMatch = matchData;
      if (matchData.matchModel.user1Id === user.id) {
        this.highColor = matchData.matchModel.user2?.profileColors?.split(",")[0] || "#fd6666";
        this.midColor = matchData.matchModel.user2?.profileColors?.split(",")[1] || "#6d4d97";
      } else {
        this.highColor = matchData.matchModel.user1?.profileColors?.split(",")[0] || "#fd6666";
        this.midColor = matchData.matchModel.user1?.profileColors?.split(",")[1] || "#6d4d97";
      }
    },

    isOnboardingActive() {
      return this.$route.path.includes('/home')
        && localStorage.getItem('eventHomeOnboardingViewed') !== 'true';
    },

    startMatchVideo(matchData) {
      this.showMatchVideo = true;
      if (matchData) {
        this.setMatchData(matchData);
      } else {
        this.fetchMatchData();
        return;
      }

      this.$nextTick(() => {
        const video = this.$refs.matchVideo;
        if (video) {
          video.play().catch(() => {
            this.onMatchVideoEnded();
          });
        }
      });
    },

    async fetchMatchData() {
      const userFromLocalStorage = localStorage.getItem("user");
      if (!userFromLocalStorage) return;

      const user = JSON.parse(userFromLocalStorage);
      try {
        const resp = await this.$axios.$get(`match/warnMatches?id=${user.id}`);
        if (resp.content !== 201) {
          if (this.isOnboardingActive()) {
            this.pendingMatchData = resp.content;
            return;
          }
          this.showMatchVideo = true;
          this.setMatchData(resp.content);
        }
      } catch (e) {}
    },

    async newConversation() {
      const user = JSON.parse(localStorage.getItem("user"));
      await this.warnMatchesConfirm();
      let idConversation = "";
      if (user.id === this.newMatch.matchModel.user1Id) {
        idConversation = this.newMatch.matchModel.user2Id;
      } else {
        idConversation = this.newMatch.matchModel.user1Id;
      }
      this.showMatchScreen = false;
      this.$router.push(`conversation?id=${idConversation}&cameFromMatchScreen=true`);
    },

    async talkLater() {
      await this.warnMatchesConfirm();
      this.showMatchScreen = false;
      this.$router.push("conversation");
    },

    async warnMatchesConfirm() {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user) return;
      try {
        await this.$axios.$get(`match/warnMatchesConfirm?id=${user.id}`);
      } catch (e) {}
    },
  },
};
